// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__25yVf","fileBtn":"File_fileBtn__3SgiK","closeBtn":"File_closeBtn__3qYyc","fileSelected":"File_fileSelected__1MyYk","disabled":"File_disabled__1DPfk"};